<motif-modal-content id="logout-warning-modal_content">
  <div class="header">
    <div class="header-icon">
      <motif-icon [iconFunction]="timerIcon" size="32" />
    </div>

    <button
      motifIconButton
      aria-label="Close modal"
      [size]="SMALL_BUTTON_SIZE"
      (click)="onStay()">
      <motif-icon [iconFunction]="closeIcon" size="24" />
    </button>
  </div>

  <h4 class="motif-h4-default-light">
    {{ 'common.timeout.modal.title' | translate }}
  </h4>

  <p [innerHTML]="timeoutMessage()"></p>
  <p [innerHTML]="'common.timeout.modal.cta' | translate"></p>
</motif-modal-content>
<motif-modal-actions id="logout-warning-modal_actions">
  <button motifButton color="secondary" type="button" (click)="onLogout()">
    {{ 'common.logout' | translate }}
  </button>
  <button motifButton color="primary" type="submit" (click)="onStay()">
    {{ 'common.timeout.modal.buttons.stay-logged-in' | translate }}
  </button>
</motif-modal-actions>
